import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Modal } from '@wordpress/components';
import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import PatternExplorerSidebar from './sidebar';
import PatternList from './patterns-list';

function PatternsExplorer(_ref) {
  let {
    initialCategory,
    patternCategories
  } = _ref;
  const [filterValue, setFilterValue] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(initialCategory === null || initialCategory === void 0 ? void 0 : initialCategory.name);
  return createElement("div", {
    className: "block-editor-block-patterns-explorer"
  }, createElement(PatternExplorerSidebar, {
    selectedCategory: selectedCategory,
    patternCategories: patternCategories,
    onClickCategory: setSelectedCategory,
    filterValue: filterValue,
    setFilterValue: setFilterValue
  }), createElement(PatternList, {
    filterValue: filterValue,
    selectedCategory: selectedCategory,
    patternCategories: patternCategories
  }));
}

function PatternsExplorerModal(_ref2) {
  let {
    onModalClose,
    ...restProps
  } = _ref2;
  return createElement(Modal, {
    title: __('Patterns'),
    closeLabel: __('Close'),
    onRequestClose: onModalClose,
    isFullScreen: true
  }, createElement(PatternsExplorer, restProps));
}

export default PatternsExplorerModal;
//# sourceMappingURL=explorer.js.map